/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Side_HelperInputs */

const en_us2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In one-sided exercises, the plan starts with the weaker side.`)
};

const pt_br2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos exercícios de um lado só, o plano começa pelo lado mais fraco.`)
};

const es_419_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En los ejercicios de un solo lado, el plan empieza por el lado más débil.`)
};

const pt_pt2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos exercícios de um só lado, o plano começa pelo lado mais fraco.`)
};

const fr_fr2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans les exercices unilatéraux, le programme commence par le côté le plus faible.`)
};

const de_de2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einseitigen Übungen beginnt der Plan mit der schwächeren Seite.`)
};

const it_it2_profile_editors_side_helper = /** @type {(inputs: Profile_Editors_Side_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negli esercizi monolaterali, la scheda parte dal lato più debole.`)
};

/**
* | output |
* | --- |
* | "In one-sided exercises, the plan starts with the weaker side." |
*
* @param {Profile_Editors_Side_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_side_helper = /** @type {((inputs?: Profile_Editors_Side_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Side_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_side_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_side_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_side_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_side_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_side_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_side_helper(inputs)
	return en_us2_profile_editors_side_helper(inputs)
});
export { profile_editors_side_helper as "profile-editors.side_helper" }